import React from 'react';

import CpdDropdown from '@/components/ui/CpdDropdown';
import { useGetOrganizations } from '@/api/hooks/organizations/useGetOrganizations';

const OrganizationsDropdown = ({
  value,
  onChange,
  label = 'Organization',
  size = 'small',
  fullWidth = true,
  required = false,
  disabled = false,
  error = false,
  helperText = '',
}) => {
  const { organizations, loading, error: apiError } = useGetOrganizations();

  return (
    <CpdDropdown
      options={organizations}
      value={value}
      onChange={onChange}
      label={label}
      size={size}
      fullWidth={fullWidth}
      required={required}
      disabled={disabled}
      error={error}
      helperText={helperText}
      loading={loading}
      apiError={apiError}
      getOptionLabel={(org) => org.name}
      getOptionValue={(org) => org.id}
      placeholder='None'
    />
  );
};

export default OrganizationsDropdown;
